import React, { useState } from "react";
import Rules from "../elements/Rules";
import { useNavigate } from "react-router-dom";
import Countdown from "../elements/Countdown";

const Opening = ({ videoSrc, handleStartQuestion }) => {
  const navigate = useNavigate();
  const [isCountdownVisible, setIsCountdownVisible] = useState(false);

  const startCountdown = () => {
    setIsCountdownVisible(true);
  };

  return (
    <>
      <div className="w-full flex justify-center items-center h-full">
        <div className="flex flex-col gap-8 w-full max-w-3xl md:p-6">
          <h1 className="text-2xl font-bold">Welcome to the Interview</h1>
          <div className="flex flex-col gap-1">
            <Rules />
            <div className="w-full aspect-[16/9] bg-gray-900 rounded-lg overflow-hidden shadow-lg relative">
              {videoSrc ? (
                <video
                  src={videoSrc}
                  controls
                  autoPlay
                  playsInline
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white bg-gray-700 p-4">
                  <p className="text-lg text-center select-none">
                    No video provided
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center items-center gap-6 text-base font-medium text-gray-500 dark:text-gray-400">
            <button
              onClick={() => navigate("/my-interviews")}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 dark:hover:bg-gray-700 dark:bg-gray-800 dark:text-gray-100 transition-colors"
            >
              Back to Interviews
            </button>
            <button
              onClick={startCountdown}
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 dark:hover:bg-blue-700 dark:bg-blue-600 dark:text-gray-100 transition-colors"
            >
              Go to Question
            </button>
          </div>
        </div>
      </div>
      <Countdown
        isOpen={isCountdownVisible}
        onCountdownComplete={handleStartQuestion}
      />
    </>
  );
};

export default Opening;
